import React from "react";
import "./performanceAnalytics.css";
import performance_analytics from "assets/awards/performance_analytics.jpg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";

const PerformanceAnalytics = () => {
  const navigate = useNavigate();

  const handleGetDemo = (e) => {
    e.preventDefault();
    navigate("../request-a-demo");
  };

  return (
    <div className="performance-analytics-container">
      <div className="performance-analytics-top-heading">
        <h1>Keep a close eye on performance</h1>
        <p>
          Performance analytics uses key performance indicators designed to show
          whether an organization achieves its set objectives within a set
          period.
        </p>
        <button onClick={handleGetDemo} className="marketingAutomation-btn">
          GET A DEMO
        </button>
      </div>

      <div className="row">
        <div className="col-12 performance-analytics-col">
          <div className="col-3">
            <div className="right-side-heading">
              <h2>Performance Analytics</h2>
              <Link
                to="performance-analytics"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Performance Analytics
              </Link>
              <Link
                to="performance-analytics-important"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Performance Analytics Important
              </Link>
              <Link
                to="performance-analytics-work"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Performance Analytics Work
              </Link>
              <Link
                to="benefits-of-performance-analytics"
                smooth={true}
                duration={500}
                offset={-90}
              >
                Benefits of Performance Analytics
              </Link>
            </div>
          </div>
          <div className="col-9">
            <div
              className="performance-analytics-section"
              id="performance-analytics"
            >
              <div className="performance-analytics-heading">
                <h2>What is Performance Analytics?</h2>
                <p>
                  Performance analytics refers to the practice of analyzing key
                  performance indicators (KPIs) in an organization to develop
                  strategies to help reach organizational goals. The aim is to
                  ensure continuous improvement across all organizational
                  functions and outputs.
                </p>
                <p>
                  Performance analytics uses key performance indicators designed
                  to show whether an organization achieves its set objectives
                  within a set period. Performance analytics uses specific
                  metrics to measure if, and how, the set objectives are being
                  achieved. They are not an aspirational goal, but a realistic
                  set of measures that are attainable.
                </p>
              </div>
              <div className="performance-analytics-img">
                <img src={performance_analytics} alt="" />
              </div>
            </div>
            <div
              className="performance-analytics-section"
              id="performance-analytics-important"
            >
              <div className="performance-analytics-heading">
                <h2>
                  Why Performance Analytics are Important for Business Owners
                </h2>
                <p>
                  Performance analytics acts as monitoring tools that enable the
                  business to keep track of organizational performance at all
                  levels. They provide a clear picture of the factors that
                  affect the performance of an organization. By understanding
                  the factors that affect business performance, the business can
                  then take the appropriate actions to make the operations more
                  efficient.
                </p>
              </div>
            </div>
            <div
              className="performance-analytics-section"
              id="performance-analytics-work"
            >
              <div className="performance-analytics-heading">
                <h2>How Performance Analytics Work</h2>
                <p>
                  Performance analytics works through the evaluation of numerous
                  measures that have the potential to affect the operations of a
                  business. The analytics can range from performance indicators
                  that businesses choose, to those that are internationally
                  recognized. For a small business, simple performance
                  indicators can be sufficient to measure how well the
                  strategies that have been put in place are working. Larger
                  businesses may use more sophisticated indicators such as the
                  thousand point strength index.
                </p>
                <p>
                  The thousand point strength index is a performance analytic
                  tool that comprehensively analyses every aspect that has the
                  potential to affect the future of an organization. Results
                  from this analysis are particularly important to executives as
                  they enable them to have a glimpse of the future and plan
                  accordingly. In addition, the analysis shows what needs to be
                  done to achieve certain goals in the future.
                </p>
              </div>
            </div>
            <div
              className="performance-analytics-section"
              id="benefits-of-performance-analytics"
            >
              <div className="performance-analytics-heading">
                <h2>Benefits of Performance Analytics</h2>
                <h4>1. Increasing Productivity</h4>
                <p>
                  Performance analytics can single out areas of poor
                  performance. In sales, for example, teams that consistently
                  have the lowest numbers can be identified and given corrective
                  training. Performance analytics make it easy to identify the
                  individual, team, or department that are not meeting KPIs and
                  management can decide the next best course of action.
                </p>
                <h4>2. Enables Data-Driven Decisions</h4>
                <p>
                  Performance analytics enables an organization to create
                  predictions of performance and diagnosis of problems in
                  different aspects of its operation. This information can then
                  be used to make future decisions to avoid negative business
                  performance. It also ensures that past mistakes which have the
                  potential to cause losses are avoided and replaced by choices
                  that are data-based.
                </p>
                <h4>3. Enhanced Future Planning</h4>
                <p>
                  Performance analytics provides data on historical events and
                  how they were addressed. Such data can be useful in predicting
                  the occurrence of similar events in the future and planning
                  for them. For example, suppose historical data shows that
                  overloading employees with work leads to attrition. In that
                  case, the organization can plan in advance to engage
                  additional employees whenever they anticipate that there will
                  be more work. By doing this, it will be possible to retain
                  valuable employees, as the mistakes that contribute to
                  attrition will have been avoided.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PerformanceAnalytics;
